import { memo } from "react";
import { AutoSizer, InfiniteLoader, List, WindowScroller } from "react-virtualized";
import { Loader, Segment } from "semantic-ui-react";
import { GetNotifyNotificationStatus } from "../../../../../../../../queries/notify";
import { useNotifyNotificationsCardInfiniteList } from "../../../hooks/useNotifyNotificationsCardInfiniteList";
import { NotifyNotificationsCard } from "./NotifyNotificationsCard";

export const NotifyNotificationsCardInfiniteList = memo(
  ({
    filters,
    showCheckboxes = false,
  }: {
    filters: {
      query: string;
      subscriptionGroupIds: number[];
      departmentGroupId: number | null;
      status: GetNotifyNotificationStatus | null;
    };
    showCheckboxes?: boolean;
  }) => {
    const {
      notifyContent,
      notifyContent2D,
      total2D,
      isNotificationContentFetching,
      loadMoreRows,
      scrollElement,
      columnCount,
    } = useNotifyNotificationsCardInfiniteList({ filters });

    if (isNotificationContentFetching && notifyContent.length === 0) {
      return (
        <Segment className='tw-h-[60vh]' basic>
          <Loader active />
        </Segment>
      );
    }

    return (
      <InfiniteLoader
        isRowLoaded={({ index }) => !!notifyContent2D[index]}
        loadMoreRows={loadMoreRows}
        rowCount={total2D}
        threshold={10}
      >
        {({ onRowsRendered, registerChild }) => (
          <WindowScroller scrollElement={scrollElement}>
            {({ height, isScrolling, onChildScroll, scrollTop }) => (
              <AutoSizer disableHeight>
                {({ width }) => (
                  <List
                    autoHeight
                    height={height}
                    isScrolling={isScrolling}
                    onScroll={onChildScroll}
                    scrollTop={scrollTop}
                    onRowsRendered={onRowsRendered}
                    ref={registerChild}
                    rowCount={notifyContent2D.length}
                    rowHeight={220}
                    rowRenderer={({ index, key, style }) => (
                      <div key={key} style={{ ...style }}>
                        <div
                          className='tw-grid tw-h-full tw-gap-3 tw-pb-3'
                          style={{
                            gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
                          }}
                        >
                          {notifyContent2D[index].map((content) => (
                            <NotifyNotificationsCard key={content.id} content={content} showCheckbox={showCheckboxes} />
                          ))}
                        </div>
                      </div>
                    )}
                    width={width}
                  />
                )}
              </AutoSizer>
            )}
          </WindowScroller>
        )}
      </InfiniteLoader>
    );
  },
);
